/**
 * Bascule thème clair/sombre.
 *
 * Un bouton plutôt qu'un `<select>` (voir `LanguageSwitcher`) : il n'y a que deux états,
 * et l'action est un aller-retour, pas un choix parmi plusieurs options. L'icône affichée
 * annonce l'état vers lequel basculer, pas l'état courant — c'est ce que l'utilisateur
 * veut savoir avant de cliquer.
 */

import { Moon, Sun } from 'react-feather';
import { useT } from '../i18n/index.js';
import { useThemeStore } from '../theme.js';

export function ThemeSwitcher(): React.JSX.Element {
  const theme = useThemeStore((state) => state.theme);
  const toggleTheme = useThemeStore((state) => state.toggleTheme);
  const translator = useT();

  const label = translator.t(theme === 'dark' ? 'app.themeToLight' : 'app.themeToDark');

  return (
    <button
      type="button"
      className="btn btn-sm"
      onClick={toggleTheme}
      aria-label={label}
      title={label}
    >
      {theme === 'dark' ? (
        <Sun size={16} strokeWidth={2.5} />
      ) : (
        <Moon size={16} strokeWidth={2.5} />
      )}
    </button>
  );
}
